import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { QuizSettingsDialogComponent } from './quiz-settings-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [QuizSettingsDialogComponent],
  imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule, SharedModule],
  exports: [QuizSettingsDialogComponent],
  entryComponents: [QuizSettingsDialogComponent],
})
export class QuizSettingsModule {}
